import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { DocsPageComponent } from "./pages/docs/docs-page.component";
import { DocumentTextComponent } from "./shared/components/document-text/document-text.component";
import { DocumentVersionsComponent } from "./pages/docs/document-versions/document-versions.component";
import { DocumentVersionComponent } from "./pages/docs/document-version/document-version.component";
import { DocumentCompareComponent } from "./pages/docs/document-compare/document-compare.component";
import { ThanksComponent } from "./pages/thanks/thanks.component";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { AppRoutingModule } from "./app-routing.module";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DataService } from "./shared/dataService";
import { DocumentService } from "./shared/services/document.service";
import { UtilMethods } from "./shared/utility-methods";
import { PricingWizardManagerService } from "./pages/marketplace/marketplace.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PlansComponent } from "./pages/plans/plans.component";
import { FooterComponent } from "./shared/components/footer/footer.component";
import { HeaderComponent } from "./shared/components/header/header.component";
import { GcpNotFoundComponent } from "./pages/gcp-not-found/gcp-not-found.component";
import { NgxCaptchaModule } from "ngx-captcha";
// import { FacenoteComponent } from './pages/facenote/facenote.component';
import { MatDialog, MatDialogModule } from "@angular/material";
import { ThankreturnComponent } from "./pages/thankreturn/thankreturn.component";
import { TermsModalComponent } from "./shared/components/terms-modal/terms-modal.component";
import { ContactFormOnlyComponent } from "./pages/marketplace-contact-form/contact-form-only.component";

@NgModule({
  declarations: [
    DocsPageComponent,
    DocumentTextComponent,
    DocumentVersionsComponent,
    DocumentVersionComponent,
    DocumentCompareComponent,
    AppComponent,
    ThanksComponent,
    PlansComponent,
    FooterComponent,
    HeaderComponent,
    GcpNotFoundComponent,
    ThankreturnComponent,
    TermsModalComponent,
    ContactFormOnlyComponent,
    // FacenoteComponent
  ],
  entryComponents: [TermsModalComponent],
  imports: [
    BrowserModule,
    // MarketPlaceModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgbModule,
    FormsModule,
    NgxUiLoaderModule,
    MatDialogModule,
    HttpClientModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
    AppRoutingModule,
    NgxCaptchaModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    DataService,
    DocumentService,
    UtilMethods,
    PricingWizardManagerService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
